module.exports = __webpack_public_path__ + "img/edge_divers_handicap.da823951.svg";